module.exports = __webpack_public_path__ + "static/media/campaigns-count-zero-state.2043fe76.svg";